import type {
  ActivateProfileResult,
  AcknowledgeFeedbackInput,
  ApplyActivationCodeInput,
  ApplyRewardCodeInput,
  AddProfileInput,
  DeleteXianyuInventoryCodesInput,
  FulfillXianyuOrderInput,
  GenerateXianyuCodesInput,
  SubmitFeedbackInput,
  AuthActionResult,
  AuthState,
  BatchUpdateProfileAvailabilityInput,
  BatchUpdateProfileNotesInput,
  BatchDeleteProfilesInput,
  DeleteProfileInput,
  EmailOtpActionResult,
  FileDialogResult,
  HeartbeatBootstrap,
  MultiFileDialogResult,
  CreateScanTicketInput,
  ConsumeScanTicketInput,
  IssueUserProfileTransferInput,
  ImportProfileTransferBatchItem,
  ImportProfileTransferBatchResult,
  ImportProfileTransferOptions,
  IssueLicenseCodeInput,
  LicenseHostOrderDeliveryActionResult,
  LicenseHostOrderDeliveryDashboardResult,
  IssueRemoteProfileTransferInput,
  IssueRemoteLicenseInput,
  InviteRecordsResult,
  LicenseHostActionResult,
  LicenseHostRemoteActionResult,
  LicenseHostRemoteDashboardResult,
  LicenseHostRemoteProfileSnapshot,
  LicenseHostRecordsResult,
  ReleaseRemoteAccountRestrictionInput,
  ResetRemoteAccountPasswordInput,
  ResetRemoteSecondaryPasswordInput,
  RevokeRemoteLicenseInput,
  SearchLicenseHostRemoteInput,
  SendEmailOtpInput,
  SetRemoteUpdateChannelInput,
  LicenseHostState,
  LoginInput,
  PasswordResetInput,
  PostSwitchDesktopLaunchInput,
  PostSwitchDesktopLaunchResult,
  ProfileTransferPackage,
  ProfileTransferResponseResult,
  SecondaryPasswordActionResult,
  ImportCurrentAuthResult,
  ImportLocalProfileImportOptions,
  InspectLocalProfileImportsResult,
  InspectManualImportTextResult,
  FloatingWidgetPreviewTransitionInput,
  FloatingWidgetState,
  LicenseSummary,
  MarkFeedbackConversationReadInput,
  MarkFeedbackReadInput,
  MarkLicenseHostActivitiesReadInput,
  NetworkAccessState,
  OAuthProviderId,
  UpdateActionResult,
  OpenPathResult,
  LocalProfileImportCandidate,
  ProfilesState,
  ProfileSummary,
  StartupProgressEvent,
  RedeemInviteCodeInput,
  RespondProfileTransferInput,
  RegisterInput,
  ScanTicket,
  SaveXianyuBotClientInput,
  SaveXianyuOrderInput,
  SaveXianyuTemplateInput,
  SaveXianyuTierInput,
  ResetSecondaryPasswordByEmailInput,
  SetSecondaryPasswordInput,
  SwitchProgressEvent,
  SwitchProfileInput,
  SyncCloudProfilesInput,
  SyncUsageResult,
  StatisticsDashboard,
  StatisticsRange,
  SwitchMode,
  TrayCardState,
  UnlockAccountBoundProfilesInput,
  UnlockAccountBoundProfilesResult,
  UpdateState,
  UpdateSourcePreference,
  UpdateAppSettingsInput,
  UpdateProfileInput,
  UserProfile,
  VerifySecondaryPasswordInput,
  WorkspaceOAuthLaunchResult,
  WindowState,
} from './types';

export const IPC_CHANNELS = {
  getAppState: 'app:get-state',
  getInitialAppState: 'app:get-initial-state',
  startupProgress: 'app:startup-progress',
  quitApp: 'app:quit',
  restartApp: 'app:restart',
  restartLicenseHost: 'license-host:restart',
  importCurrentAuth: 'app:import-current-auth',
  importProfileTransferPackage: 'app:import-profile-transfer-package',
  importProfileTransferPackagesBatch: 'app:import-profile-transfer-packages-batch',
  inspectLocalProfileImports: 'app:inspect-local-profile-imports',
  inspectManualImportText: 'app:inspect-manual-import-text',
  importLocalProfileImportCandidate: 'app:import-local-profile-import-candidate',
  getRemoteProfileSnapshots: 'app:get-remote-profile-snapshots',
  syncUsage: 'app:sync-usage',
  getStatisticsDashboard: 'app:get-statistics-dashboard',
  runPostSwitchDesktopLaunch: 'app:run-post-switch-desktop-launch',
  listProfiles: 'profiles:list',
  refreshProfiles: 'profiles:refresh',
  profilesStateChanged: 'profiles:state-changed',
  addProfile: 'profiles:add',
  updateProfile: 'profiles:update',
  batchUpdateProfileAvailability: 'profiles:batch-update-availability',
  batchUpdateProfileNotes: 'profiles:batch-update-notes',
  batchDeleteProfiles: 'profiles:batch-delete',
  unlockAccountBoundProfiles: 'profiles:unlock-account-bound-profiles',
  deleteProfile: 'profiles:delete',
  switchProfile: 'profiles:switch',
  switchProgress: 'profiles:switch-progress',
  chooseAuthFile: 'dialog:choose-auth-file',
  chooseLocalImportFiles: 'dialog:choose-local-import-files',
  chooseExecutableFile: 'dialog:choose-executable-file',
  chooseDirectory: 'dialog:choose-directory',
  chooseRootDirectory: 'dialog:choose-root-directory',
  setProfilesRootDir: 'settings:set-profiles-root',
  updateSettings: 'settings:update',
  setTrayHoverCardEnabled: 'settings:set-tray-hover-card-enabled',
  setFloatingWidgetEnabled: 'settings:set-floating-widget-enabled',
  openPath: 'shell:open-path',
  openExternal: 'shell:open-external',
  startWorkspaceOAuth: 'shell:start-workspace-oauth',
  getNetworkAccessState: 'shell:get-network-access-state',
  windowMinimize: 'window:minimize',
  windowToggleMaximize: 'window:toggle-maximize',
  windowClose: 'window:close',
  windowHide: 'window:hide',
  windowShow: 'window:show',
  windowGetState: 'window:get-state',
  windowStateChanged: 'window:state-changed',
  trayCardGetState: 'tray-card:get-state',
  trayCardStateChanged: 'tray-card:state-changed',
  floatingWidgetGetState: 'floating-widget:get-state',
  floatingWidgetStateChanged: 'floating-widget:state-changed',
  floatingWidgetToggleMode: 'floating-widget:toggle-mode',
  floatingWidgetPreviewTransition: 'floating-widget:preview-transition',
  floatingWidgetDragStart: 'floating-widget:drag-start',
  floatingWidgetDragMove: 'floating-widget:drag-move',
  floatingWidgetDragEnd: 'floating-widget:drag-end',
  openLicenseHostWindow: 'app:open-license-host-window',
  updateGetState: 'update:get-state',
  updateGetSourcePreference: 'update:get-source-preference',
  updateSetSourcePreference: 'update:set-source-preference',
  updateCheck: 'update:check',
  updateDownloadAndInstall: 'update:download-and-install',
  updateOpenNotes: 'update:open-notes',
  updateStateChanged: 'update:state-changed',
  authGetState: 'auth:get-state',
  authLogin: 'auth:login',
  authRegister: 'auth:register',
  authLogout: 'auth:logout',
  authSendEmailOtp: 'auth:send-email-otp',
  authRequestPasswordReset: 'auth:request-password-reset',
  authCreateScanTicket: 'auth:create-scan-ticket',
  authGetScanTicket: 'auth:get-scan-ticket',
  authGetScanCodeUrl: 'auth:get-scan-code-url',
  authConsumeScanTicket: 'auth:consume-scan-ticket',
  authGetAccountProfile: 'auth:get-account-profile',
  authGetLicenseSummary: 'auth:get-license-summary',
  authApplyActivationCode: 'auth:apply-activation-code',
  authRequestInviteCode: 'auth:request-invite-code',
  authRedeemInviteCode: 'auth:redeem-invite-code',
  authClaimInviteReward: 'auth:claim-invite-reward',
  authApplyRewardCode: 'auth:apply-reward-code',
  authListInviteRecords: 'auth:list-invite-records',
  authSubmitFeedback: 'auth:submit-feedback',
  authMarkFeedbackConversationRead: 'auth:mark-feedback-conversation-read',
  authIssueUserProfileTransfer: 'auth:issue-user-profile-transfer',
  authRespondProfileTransfer: 'auth:respond-profile-transfer',
  authSetSecondaryPassword: 'auth:set-secondary-password',
  authResetSecondaryPasswordByEmail: 'auth:reset-secondary-password-by-email',
  authVerifySecondaryPassword: 'auth:verify-secondary-password',
  authSyncCloudProfiles: 'auth:sync-cloud-profiles',
  authHeartbeat: 'auth:heartbeat',
  authGetHeartbeatBootstrap: 'auth:get-heartbeat-bootstrap',
  authStateChanged: 'auth:state-changed',
  licenseHostGetState: 'license-host:get-state',
  licenseHostIssueCode: 'license-host:issue-code',
  licenseHostSearchRecords: 'license-host:search-records',
  licenseHostGetRemoteDashboard: 'license-host:get-remote-dashboard',
  licenseHostIssueRemoteLicense: 'license-host:issue-remote-license',
  licenseHostSetRemoteUpdateChannel: 'license-host:set-remote-update-channel',
  licenseHostRevokeRemoteLicense: 'license-host:revoke-remote-license',
  licenseHostReleaseRemoteAccountRestriction: 'license-host:release-remote-account-restriction',
  licenseHostResetRemotePassword: 'license-host:reset-remote-password',
  licenseHostResetRemoteSecondaryPassword: 'license-host:reset-remote-secondary-password',
  licenseHostIssueRemoteProfileTransfer: 'license-host:issue-remote-profile-transfer',
  licenseHostMarkActivitiesRead: 'license-host:mark-activities-read',
  licenseHostMarkFeedbackRead: 'license-host:mark-feedback-read',
  licenseHostAcknowledgeFeedback: 'license-host:acknowledge-feedback',
  licenseHostGetOrderDeliveryDashboard: 'license-host:get-order-delivery-dashboard',
  licenseHostSaveOrderDeliveryTier: 'license-host:save-order-delivery-tier',
  licenseHostSaveOrderDeliveryTemplate: 'license-host:save-order-delivery-template',
  licenseHostSaveOrderDeliveryOrder: 'license-host:save-order-delivery-order',
  licenseHostGenerateOrderDeliveryCodes: 'license-host:generate-order-delivery-codes',
  licenseHostDeleteOrderDeliveryCodes: 'license-host:delete-order-delivery-codes',
  licenseHostFulfillOrderDeliveryOrder: 'license-host:fulfill-order-delivery-order',
  licenseHostSaveOrderDeliveryBot: 'license-host:save-order-delivery-bot',
} as const;

export interface CodexWorkspaceApi {
  getAppState: () => Promise<ProfilesState>;
  getInitialAppState: () => Promise<ProfilesState>;
  onStartupProgress: (listener: (event: StartupProgressEvent) => void) => () => void;
  quitApp: () => void;
  restartApp: () => void;
  restartLicenseHost: () => Promise<{ ok: true }>;
  importCurrentAuth: () => Promise<ImportCurrentAuthResult>;
  importProfileTransferPackage: (
    profilePackage: ProfileTransferPackage,
    options?: ImportProfileTransferOptions,
  ) => Promise<ImportCurrentAuthResult>;
  importProfileTransferPackagesBatch: (
    items: ImportProfileTransferBatchItem[],
  ) => Promise<ImportProfileTransferBatchResult>;
  inspectLocalProfileImports: (filePaths: string[]) => Promise<InspectLocalProfileImportsResult>;
  inspectManualImportText: (rawText: string) => Promise<InspectManualImportTextResult>;
  importLocalProfileImportCandidate: (
    candidate: LocalProfileImportCandidate,
    options?: ImportLocalProfileImportOptions,
  ) => Promise<ImportCurrentAuthResult>;
  resolveDroppedFilePaths: (files: File[]) => string[];
  getRemoteProfileSnapshots: () => Promise<LicenseHostRemoteProfileSnapshot[]>;
  syncUsage: () => Promise<SyncUsageResult>;
  getStatisticsDashboard: (
    range: StatisticsRange,
    mode?: SwitchMode,
  ) => Promise<StatisticsDashboard>;
  runPostSwitchDesktopLaunch: (
    input: PostSwitchDesktopLaunchInput,
  ) => Promise<PostSwitchDesktopLaunchResult>;
  listProfiles: () => Promise<ProfileSummary[]>;
  refreshProfiles: () => Promise<ProfilesState>;
  onProfilesStateChange: (listener: (state: ProfilesState) => void) => () => void;
  addProfile: (input: AddProfileInput) => Promise<ProfilesState>;
  updateProfile: (input: UpdateProfileInput) => Promise<ProfilesState>;
  batchUpdateProfileAvailability: (
    input: BatchUpdateProfileAvailabilityInput,
  ) => Promise<ProfilesState>;
  batchUpdateProfileNotes: (input: BatchUpdateProfileNotesInput) => Promise<ProfilesState>;
  batchDeleteProfiles: (input: BatchDeleteProfilesInput) => Promise<ProfilesState>;
  unlockAccountBoundProfiles: (
    input: UnlockAccountBoundProfilesInput,
  ) => Promise<UnlockAccountBoundProfilesResult>;
  deleteProfile: (input: DeleteProfileInput) => Promise<ProfilesState>;
  switchProfile: (input: SwitchProfileInput) => Promise<ActivateProfileResult>;
  onSwitchProgress: (listener: (event: SwitchProgressEvent) => void) => () => void;
  chooseAuthFile: () => Promise<FileDialogResult>;
  chooseLocalImportFiles: () => Promise<MultiFileDialogResult>;
  chooseExecutableFile: (title?: string) => Promise<FileDialogResult>;
  chooseDirectory: () => Promise<FileDialogResult>;
  chooseRootDirectory: () => Promise<FileDialogResult>;
  setProfilesRootDir: (rootDir: string) => Promise<ProfilesState>;
  updateSettings: (input: UpdateAppSettingsInput) => Promise<ProfilesState>;
  setTrayHoverCardEnabled: (enabled: boolean) => Promise<ProfilesState>;
  setFloatingWidgetEnabled: (enabled: boolean) => Promise<ProfilesState>;
  openPath: (targetPath: string) => Promise<OpenPathResult>;
  openExternal: (targetUrl: string) => Promise<OpenPathResult>;
  startWorkspaceOAuth: (providerId?: OAuthProviderId) => Promise<WorkspaceOAuthLaunchResult>;
  getNetworkAccessState: () => Promise<NetworkAccessState>;
  minimizeWindow: () => Promise<WindowState>;
  toggleMaximizeWindow: () => Promise<WindowState>;
  closeWindow: () => Promise<WindowState>;
  hideWindow: () => Promise<WindowState>;
  showWindow: () => Promise<WindowState>;
  getWindowState: () => Promise<WindowState>;
  onWindowStateChange: (listener: (state: WindowState) => void) => () => void;
  getTrayCardState: () => Promise<TrayCardState>;
  onTrayCardStateChange: (listener: (state: TrayCardState) => void) => () => void;
  getFloatingWidgetState: () => Promise<FloatingWidgetState>;
  onFloatingWidgetStateChange: (listener: (state: FloatingWidgetState) => void) => () => void;
  toggleFloatingWidgetMode: () => Promise<FloatingWidgetState>;
  floatingWidgetPreviewTransition: (
    input: FloatingWidgetPreviewTransitionInput,
  ) => Promise<FloatingWidgetState>;
  startFloatingWidgetDrag: (screenX: number, screenY: number) => void;
  updateFloatingWidgetDrag: (screenX: number, screenY: number) => void;
  endFloatingWidgetDrag: () => void;
  openLicenseHostWindow: () => Promise<{ ok: true }>;
  getUpdateState: () => Promise<UpdateState>;
  getUpdateSourcePreference: () => Promise<UpdateSourcePreference>;
  setUpdateSourcePreference: (sourcePreference: UpdateSourcePreference) => Promise<UpdateActionResult>;
  checkForUpdates: () => Promise<UpdateActionResult>;
  downloadAndInstallUpdate: () => Promise<UpdateActionResult>;
  openUpdateNotes: () => Promise<OpenPathResult>;
  onUpdateStateChange: (listener: (state: UpdateState) => void) => () => void;
  getAuthState: () => Promise<AuthState>;
  login: (input: LoginInput) => Promise<AuthActionResult>;
  register: (input: RegisterInput) => Promise<AuthActionResult>;
  logout: () => Promise<AuthActionResult>;
  sendEmailOtp: (input: SendEmailOtpInput) => Promise<EmailOtpActionResult>;
  requestPasswordReset: (input: PasswordResetInput) => Promise<AuthActionResult>;
  createScanTicket: (input?: CreateScanTicketInput) => Promise<ScanTicket>;
  getScanTicket: (ticketId: string) => Promise<ScanTicket>;
  getScanCodeUrl: (ticketId: string) => Promise<string>;
  consumeScanTicket: (input: ConsumeScanTicketInput) => Promise<AuthActionResult>;
  getAccountProfile: () => Promise<UserProfile | null>;
  getLicenseSummary: () => Promise<LicenseSummary>;
  applyActivationCode: (input: ApplyActivationCodeInput) => Promise<AuthActionResult>;
  requestInviteCode: () => Promise<AuthActionResult>;
  redeemInviteCode: (input: RedeemInviteCodeInput) => Promise<AuthActionResult>;
  claimInviteReward: () => Promise<AuthActionResult>;
  applyRewardCode: (input: ApplyRewardCodeInput) => Promise<AuthActionResult>;
  listInviteRecords: () => Promise<InviteRecordsResult>;
  submitFeedback: (input: SubmitFeedbackInput) => Promise<AuthActionResult>;
  markFeedbackConversationRead: (input: MarkFeedbackConversationReadInput) => Promise<AuthActionResult>;
  issueUserProfileTransfer: (input: IssueUserProfileTransferInput) => Promise<AuthActionResult>;
  respondToProfileTransfer: (
    input: RespondProfileTransferInput,
  ) => Promise<ProfileTransferResponseResult>;
  setSecondaryPassword: (
    input: SetSecondaryPasswordInput,
  ) => Promise<SecondaryPasswordActionResult>;
  resetSecondaryPasswordByEmail: (
    input: ResetSecondaryPasswordByEmailInput,
  ) => Promise<SecondaryPasswordActionResult>;
  verifySecondaryPassword: (
    input: VerifySecondaryPasswordInput,
  ) => Promise<SecondaryPasswordActionResult>;
  syncCloudProfiles: (input: SyncCloudProfilesInput) => Promise<AuthActionResult>;
  heartbeat: () => Promise<AuthActionResult>;
  getHeartbeatBootstrap: () => Promise<HeartbeatBootstrap>;
  onAuthStateChange: (listener: (state: AuthState) => void) => () => void;
  getLicenseHostState: () => Promise<LicenseHostState>;
  issueLicenseCode: (input: IssueLicenseCodeInput) => Promise<LicenseHostActionResult>;
  searchLicenseHostRecords: (query: string) => Promise<LicenseHostRecordsResult>;
  getLicenseHostRemoteDashboard: (
    input?: SearchLicenseHostRemoteInput,
  ) => Promise<LicenseHostRemoteDashboardResult>;
  issueRemoteLicense: (input: IssueRemoteLicenseInput) => Promise<LicenseHostRemoteActionResult>;
  setRemoteUpdateChannel: (
    input: SetRemoteUpdateChannelInput,
  ) => Promise<LicenseHostRemoteActionResult>;
  revokeRemoteLicense: (
    input: RevokeRemoteLicenseInput,
  ) => Promise<LicenseHostRemoteActionResult>;
  releaseRemoteAccountRestriction: (
    input: ReleaseRemoteAccountRestrictionInput,
  ) => Promise<LicenseHostRemoteActionResult>;
  resetRemotePassword: (
    input: ResetRemoteAccountPasswordInput,
  ) => Promise<LicenseHostRemoteActionResult>;
  resetRemoteSecondaryPassword: (
    input: ResetRemoteSecondaryPasswordInput,
  ) => Promise<LicenseHostRemoteActionResult>;
  issueRemoteProfileTransfer: (
    input: IssueRemoteProfileTransferInput,
  ) => Promise<LicenseHostRemoteActionResult>;
  markLicenseHostActivitiesRead: (
    input: MarkLicenseHostActivitiesReadInput,
  ) => Promise<LicenseHostRemoteActionResult>;
  markFeedbackRead: (input: MarkFeedbackReadInput) => Promise<LicenseHostRemoteActionResult>;
  acknowledgeFeedback: (
    input: AcknowledgeFeedbackInput,
  ) => Promise<LicenseHostRemoteActionResult>;
  getLicenseHostOrderDeliveryDashboard: () => Promise<LicenseHostOrderDeliveryDashboardResult>;
  saveLicenseHostOrderDeliveryTier: (
    input: SaveXianyuTierInput,
  ) => Promise<LicenseHostOrderDeliveryActionResult>;
  saveLicenseHostOrderDeliveryTemplate: (
    input: SaveXianyuTemplateInput,
  ) => Promise<LicenseHostOrderDeliveryActionResult>;
  saveLicenseHostOrderDeliveryOrder: (
    input: SaveXianyuOrderInput,
  ) => Promise<LicenseHostOrderDeliveryActionResult>;
  generateLicenseHostOrderDeliveryCodes: (
    input: GenerateXianyuCodesInput,
  ) => Promise<LicenseHostOrderDeliveryActionResult>;
  deleteLicenseHostOrderDeliveryCodes: (
    input: DeleteXianyuInventoryCodesInput,
  ) => Promise<LicenseHostOrderDeliveryActionResult>;
  fulfillLicenseHostOrderDeliveryOrder: (
    input: FulfillXianyuOrderInput,
  ) => Promise<LicenseHostOrderDeliveryActionResult>;
  saveLicenseHostOrderDeliveryBot: (
    input: SaveXianyuBotClientInput,
  ) => Promise<LicenseHostOrderDeliveryActionResult>;
}
